/* global app */
/* global mdc */
/* global gui */
/* global angular */
/* global Quill, $ */

app.directive("fileread", [function() {
    return {
        scope: {
            fileread: "="
        },
        link: function(scope, element, attributes) {
            element.bind("change", function(changeEvent) {
                var reader = new FileReader();
                reader.onload = function(loadEvent) {
                    scope.$apply(function() {
                        scope.fileread = loadEvent.target.result;
                    });
                }
                reader.readAsDataURL(changeEvent.target.files[0]);
            });
        }
    }
}]);

app.directive("acOpenDialog", ['$rootScope', function($rootScope) {
    return {
        link: function(scope, element, attributes) {
            element.bind("click", function(event) {
                var dialogId = attributes.acOpenDialog;
                var dataTarget = attributes.acOpenDialogTarget
                var dialogDataString = angular.fromJson(attributes.dialogInit);
                gui.openDialog(dialogId);
                $rootScope.$emit(dialogId, { command: "open", data: dialogDataString, dataTarget:dataTarget });
            });
        }
    }
}]);



app.directive("acEditableImage", ['$rootScope', function($rootScope) {
    return {
        link: function(scope, element, attributes) {
            element.on("mouseover", function(event) {
                element.parent().css("position", "relative")
                element.parent().prepend('<i class="material-icons administer-event-image-icon">edit</i>')
            });
        }
    }
}]);





app.directive("acSelect", [function($rootScope) {
    return {
        priority: 100,
        link: function(scope, element, attributes) {
            gui.onFinished(function() {
                var drop = gui.dropDowns[element.attr("id")]
                var modelName = attributes["acSelect"]
                var changeCallback = attributes["acSelectChange"]
                drop.listen("MDCSelect:change", function(e) {
                    eval("scope." + modelName + " = '" + e.detail.value + "'");

                    if(changeCallback != undefined && changeCallback != ""){
                        eval("scope." + changeCallback);
                    }
                    scope.$apply()
                })
            })
        }
    }
}]);

app.directive("acInitOnDialogOpen", ['$rootScope', function($rootScope) {
    return {
        priority: 100,
        link: function(scope, element, attributes) {
            var _self = this;
            var dialogName = attributes["acInitOnDialogOpen"]
            var sliderName = attributes["id"];
            var initType = attributes["acInitType"];
            
            if(initType == "menuSurface"){
                gui.onFinished(function() {
                    gui.dialogs[dialogName].listen("MDCDialog:opened", function() {
                            window.surface = element[0];
                            var el = new mdc.menuSurface.MDCMenuSurface(element[0])
                            el.open = true;
                    })
                })
            }else{
                var slider = new mdc.slider.MDCSlider(element[0]);
                gui.registerSlider(sliderName, slider);
                gui.onFinished(function() {
                    gui.dialogs[dialogName].listen("MDCDialog:opened", function() {
                        slider.layout();
                    })
                })
            }
        }
    }
}]);

app.directive("acSlider", [function($rootScope) {
    return {
        priority: 200,
        link: function(scope, element, attributes) {
            gui.onFinished(function() {
                var modelName = attributes["acSlider"];
                var sliderName = attributes["id"];
                gui.sliders[sliderName].listen("MDCSlider:change", function(e) {
                    var value =gui.sliders[sliderName].foundation_.getValue();
                    eval("scope." + modelName + " = '" + value + "'");
                    scope.$apply();
                    if (attributes["acSliderChanged"] != undefined) {
                        eval("scope." + attributes["acSliderChanged"]);
                    }
                })
            })

        }
    }
}]);

app.directive("acShortText", [function($rootScope) {
    return {
        priority: 200,
        link: function(scope, element, attributes) {
            scope.directivegui = {savebutton:{show:false}}
            scope.contentChanged = function(){
                scope.directivegui.savebutton.show = true; 
            }
        }
    }
}]);


app.directive("acRenderWhenVisible", ['$rootScope', function($rootScope) {
    return {
        compile: function(element, attributes) {
            return {
                pre: function(scope, element, attributes) {
                    var componentMapping = {"MDCTextField": "mdc-text-field"}
                    var type = attributes.acRenderWhenVisible;
                    scope.$watch(attributes.ngShow, function(isVisible) {
                        if(isVisible){
                            var component = element.find("."+componentMapping[type]);
                            setTimeout(function(){
                                new mdc.textField.MDCTextField(component[0]);
                            },100)
                        }
                    });
                }
            }
        }
    }
}]);

app.directive("acDialog", ['$rootScope', function($rootScope) {
    return {
        compile: function(element, attributes) {
            return {
                pre: function(scope, element, attributes) {
                    if(scope.gui == undefined){
                        scope.gui = {};
                    }
                    scope.requiredModels = [];
                    scope.dialogInitVars = {}
                    var dialogName = attributes.id
                    $rootScope.$on(dialogName, function(e, data) {
                        try{
                        scope.dialogInitVars = data.data;
                        }catch(e){
                            
                        }
                    })
                }
            }
        }
    }
}]);

app.directive("acRequiredModel", [function($rootScope) {
    return {
        link: function(scope, element, attributes) {
            if (scope.requiredModels === undefined) {
                throw new Error("ac-required-model directive is set but requiredModels array is undefined!");
            }

            if (scope.checkRequired !== undefined) {
                console.log("Warning: checkRequired is already defined and will be overwritten!");
            }

            if (scope.requiredFieldsChecked === undefined) {
                console.log("Warning: requiredFieldsChecked function is not set!");
            }

            scope.checkRequired = function() {
                var allFieldsPresent = true;
                scope.requiredModels.forEach(function(modelName) {
                    var value = scope.$eval(modelName);
                    if (value === undefined || value == "") {
                        allFieldsPresent = false;
                    }
                })
                scope.requiredFieldsChecked(allFieldsPresent)
            }
            var modelName = attributes["acRequiredModel"]
            scope.requiredModels.push(modelName)
            scope.$watch(modelName, function(v) {
                scope.checkRequired()
            });
        }
    }
}]);

app.directive("acGroupPermissionView", [function($rootScope) {
    return {
        link: function(scope, element, attributes) {
            if (scope.addNewGroup === undefined) {
                throw new Error("ac-group-permission-view directive is set but addNewGroup function is undefined!");
            }

            if (scope.removeGroup === undefined) {
                throw new Error("ac-group-permission-view directive is set but removeGroup function is undefined!");
            }
            
            scope.editView = {show: false};
            scope.selectedPermissionLevel = "";
            
            scope.setGroupPermissions = function(groups){
                scope.groupPermissions = groups;
            }
            
            scope.setExistingGroups = function(existingGroups){
                scope.existingGroups = existingGroups;
            }
            
            scope.addGroup = function(group){
                scope.selectedGroup = group;
                scope.searchfield = group.Gruppenname
            }
            
            scope.showEditView = function(){
                scope.editView.show = true;
            }
            
            scope.hideEditView = function(){
                scope.editView.show = false;
            }

            scope.addGroupPermissionProxy = function(){
                scope.addNewGroup(scope.selectedGroup, scope.selectedPermissionLevel);
                scope.hideEditView();
            }
            
            scope.removeGroupProxy = function(group){
                scope.removeGroup(group)
            }

            scope.searchChanged = function(){
                var dropDown = element.find(".ac-dropdown_search-search_field");
                //dropDown.addClass("mdc-menu-surface--open")
            }
            
            scope.checkRequired = function() {
                var allFieldsPresent = true;
                scope.requiredModels.forEach(function(modelName) {
                    var value = scope.$eval(modelName);
                    if (value === undefined || value == "") {
                        allFieldsPresent = false;
                    }
                })
                scope.requiredFieldsChecked(allFieldsPresent)
            }
        }
    }
}]);

/*
Notification.requestPermission(function(status) {
    console.log('Notification permission status:', status);
});

function displayNotification() {
  if (Notification.permission == 'granted') {
    navigator.serviceWorker.getRegistration().then(function(reg) {
      var options = {
        body: 'Here is a notification body!',
        icon: 'images/example.png',
        vibrate: [100, 50, 100],
        data: {
          dateOfArrival: Date.now(),
          primaryKey: 1
        },
        actions: [
          {action: 'explore', title: 'Explore this new world',
            icon: 'images/checkmark.png'},
          {action: 'close', title: 'Close notification',
            icon: 'images/xmark.png'},
        ]
      };
      reg.showNotification('Hello world!', options);
    });
  }
}*/